<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100" v-if="pass.status == 'apv'">
				<h3 class="order-title">Ticket Code</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100" v-if="pass.status == 'apv'"
				style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
				<qr-code :text="'https://airandtech.show/pass/' + pass.hash_id" :size="160"
					style="width: 200px;border:10px solid white"></qr-code>
				<a :href="'https://airandtech.show/pass/' + pass.hash_id" target="_blank">
					<md-button class="md-raised md-success" style="width:100%">SHOW TICKET</md-button>
				</a>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Pass Information</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table>
					<tr>
						<td style="width: 150px">Pass ID</td>
						<td style="width: 40px">:</td>
						<td><b>{{config.orderlify(pass.id)}}</b></td>
					</tr>
					<!-- <tr>
						<td>Reference Code</td>
						<td>:</td>
						<td>{{pass.reference_code}}</td>
					</tr> -->
					<tr>
						<td>Name</td>
						<td>:</td>
						<td>{{pass.name}}</td>
					</tr>
					<tr>
						<td>Sex</td>
						<td>:</td>
						<td>{{config.getGender(pass.gender)}}</td>
					</tr>
					<tr>
						<td>Date of Birth</td>
						<td>:</td>
						<td>{{config.datelify(pass.dob)}}</td>
					</tr>
					<tr>
						<td>Phone Number</td>
						<td>:</td>
						<td>{{pass.phone}}</td>
					</tr>
					<tr>
						<td>E-Mail</td>
						<td>:</td>
						<td>{{pass.email}}</td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table style="border-width: 0px;">
					<tr>
						<td style="width: 150px">Province</td>
						<td style="width:40px">:</td>
						<td>{{pass.province_name.split("||")[1]}}</td>
					</tr>
					<tr>
						<td>District</td>
						<td>:</td>
						<td>{{pass.district_name.split("||")[1]}}</td>
					</tr>
					<tr>
						<td>Commune</td>
						<td>:</td>
						<td>{{pass.commune_name}}</td>
					</tr>
					<tr>
						<td>Address</td>
						<td>:</td>
						<td>{{pass.address_text}}</td>
					</tr>
					<tr>
						<td>Status</td>
						<td>:</td>
						<td>
							<span class="neutral" v-if="pass.status == 'pnd'">{{config.getStatus(pass.status)}}</span>
							<span class="late" v-if="pass.status == 'rjt'">{{config.getStatus(pass.status)}}</span>
							<span class="active" v-if="pass.status == 'apv'">{{config.getStatus(pass.status)}}</span>
						</td>
					</tr>
					<tr v-if="pass.status == 'apv'">
						<td>Approved by</td>
						<td>:</td>
						<td>{{pass.approved_by}}</td>
					</tr>
					<tr v-if="pass.status == 'rjt'">
						<td>Rejected by</td>
						<td>:</td>
						<td>{{pass.approved_by}}</td>
					</tr>
				</table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Personal Information</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<img :src="config.getImageUrl(pass.id_card_url)">
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<img :src="config.getImageUrl(pass.selfie_url)">
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<img :src="config.getImageUrl(pass.vaccination_card_url)">
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<img :src="config.getImageUrl(pass.vaccination_card_back_url)">
			</div>
			<div class="md-layout-item md-size-100 text-right" v-if="pass.status == 'pnd'">
				<md-button class="md-raised md-danger" @click="rejectDialog = true">Reject</md-button>
				<md-button class="md-raised md-success" @click="approveDialog = true">Approve</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="rejectDialog" md-title="Are you sure want to reject this application ?"
			md-content="" md-confirm-text="Confirm" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="reject()" />

		<md-dialog-confirm :md-active.sync="approveDialog" md-title="Are you sure want to approve this application ?"
			md-content="" md-confirm-text="Confirm" md-cancel-text="Cancel" @md-cancel="onCancel"
			@md-confirm="approve()" />
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		created() {
			this.getTicket();
		},
		data() {
			return {
				loaded: false,
				// paymentList: [],
				rejectDialog: false,
				approveDialog: false,
				pass: {
					id: "",
					reference_code: "",
					hash_id: "",
					name: "",
					phone: "",
					email: "",
					gender: "",
					dob: "",
					status: "",
					province_name: "",
					district_name: "",
					commune_name: "",
					address_text: "",
					id_card_url: "",
					selfie_url: "",
					vaccination_card_url: "",
					vaccination_card_back_url: "",
					approved_by: "",
					created_date: ""
				},
			}
		},
		methods: {
			getTicket(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/ticket/get/" + this.$route.params.hash_id).then(data => {
					this.pass = data.body.data
					this.loaded = true
				})
			},
			approve() {
				this.$http.post(this.config.api + "/admin/ticket/approve", {
					id: parseInt(this.pass.id),
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "Application was approved successfully.",
							icon: 'done',
							type: 'success'
						});
						this.getTicket();
					}
				})
			},
			reject() {
				this.$http.post(this.config.api + "/admin/ticket/reject", {
					id: parseInt(this.pass.id),
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "Application was rejected successfully.",
							icon: 'done',
							type: 'success'
						})
						this.getTicket();
					}
				})
			},
			onCancel() {
				this.approveDialog = false;
				this.rejectDialog = false;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Passes/Detail.vue